import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import "./BonusTile.scss";
import Slider from "react-slick";
import Utils from "../../../utils/Utils";
import Icons from "../../../assets/Icons/Icons";
import * as storeActions from "../../../../src/store/actions";
import { withTranslation } from "react-i18next";
import { getSelectedBonusValue } from "../../ClaimBonus/BonusAvailableWidget/BonusAvailableWidget";
import * as stateActions from "../../../store/actions";

class BonusTile extends Component {

    constructor(props) {
        super(props);
        this.paymentMethod = props.paymentMethod ?? null;
    }

    state = {
        bonus: false,
        time: 0
    }

    getBonuses() {
        if (this.paymentMethod) {
            this.props.getEligibleBonuses([this.paymentMethod]);
        } else {
            this.props.getEligibleBonuses();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.paymentMethod !== this.props.paymentMethod) {
            Utils.delayedFunction("getBonusesFromServer", this.getBonuses.bind(this), 100);
        }
    }

    componentWillMount() {
        // if (!this.props.promotions.length) {

        Utils.delayedFunction("getBonusesFromServer", this.getBonuses.bind(this), 100)


        let hash = window.location.hash;

        if (hash.length) {
            if (this.props.onClickedBonus) {

                this.setState({
                    ...this.state,
                    bonus: parseInt(hash.substr(1), 10)
                });
                this.props.onClickedBonus(parseInt(hash.substr(1), 10));
            }
        }

        // }
        // this.props.requestTransactionsHistory();
    }

    componentDidMount() {
        if (this.state.bonus) {
            window.location.hash = ''
            this.props.closeRightMenu();
        }
    }

    // getCurrentStep() {
    //     let now = new Date().getTime()/1000;
    //     let registerDate = this.props.profile.date_created;
    //     let maxDiff = 86400 * MAX_DAYS;
    //     let step = false;
    //     let lastValue = 0;
    //     let time = registerDate +  maxDiff;
    //     // check register
    //     if (now - registerDate < maxDiff) {
    //         step = 0;
    //     }
    //
    //     // check bonuses for step 2
    //     if(this.props.transactions.bonuses) {
    //         // get last bonus
    //        let index = 0;
    //        let id = typeof this.props.transactions.bonuses[0] !== "undefined" ?  this.props.transactions.bonuses[0].id : 0;
    //         Object.keys(this.props.transactions.bonuses).forEach((key) => {
    //             let cB = this.props.transactions.bonuses[key];
    //             if (typeof  cB !== "undefined") {
    //                 if (cB.id > id) {
    //                     index = key;
    //                 }
    //             }
    //         })
    //         let bonus = this.props.transactions.bonuses[index];
    //
    //         if (typeof bonus !== "undefined") {
    //             if ( bonus.status !== 1 ||
    //                 (bonus.status === 1 && bonus.endDate < now) ||
    //                 (bonus.status === 1 && bonus.endDate > now && this.props.wallet.total < 1)) {
    //                 // step = this.props.transactions.bonuses.length;
    //                 lastValue = bonus.bonusId;
    //                 time = bonus.startDate  + 86400 * MAX_DAYS;
    //
    //             } else {
    //                 step = false;
    //             }
    //
    //         }
    //     }
    //     if (step !== false) {
    //         //set Time
    //         if(!this.state.time) {
    //             Utils.delayedFunction('initTimer',this.initTimer.bind(this,time+2),1000);
    //         }
    //     }
    //
    //     return step !== false ? {lastValue: lastValue} : step;
    // }

    // initTimer(time) {
    //     this.setState({
    //         ...this.state,
    //         time: time
    //     })
    // }

    // decrementTimer() {
    //     this.setState({
    //         ...this.state,
    //         time: this.state.time // we don't need to decrement it, but we need to reinit it.!!!
    //     })
    // }

    getTimer() {
        //     let time = parseInt(this.state.time);
        //     let now = new Date().getTime()/1000;
        //     let days = parseInt((time - now)/86400,10);
        //
        //     let diffSeconds =  parseInt((time-now-(days * 86400) ),10);
        //     if (diffSeconds < 0) {
        //         diffSeconds = -diffSeconds;
        //     }
        //     let hour = parseInt(diffSeconds/3600,10);
        //     let minutes = parseInt((diffSeconds - (hour*3600))/60,10);
        //     let seconds = parseInt(diffSeconds - (hour*3600) - (minutes*60),10);
        //     let daysHTML = []
        //     if (days) {
        //         daysHTML.push(<div className="days" key={"bonusdays"}>{days} zile</div>)
        //     }
        //
        //     Utils.delayedFunction('decrementTimer',this.decrementTimer.bind(this),1000);
        //
        //     return (
        //         <div className="timer" key={"bonustimer"}>
        //             {daysHTML}
        //             <div className={"time"} > {hour < 10 ? "0" + hour : hour}:{minutes < 10 ? "0" + minutes : minutes}:{seconds < 10 ? "0" + seconds : seconds} sec</div>
        //         </div>
        //     )
        //
        return (
            <div className="timer" key={"bonustimer"}>

                <div className={"time"} >{this.props.t("Time left:")}</div> {this.props.t("Unlimited")}
            </div>
        )
    }

    clickBonus(bonus) {
        if (typeof bonus.bonus_conflicts !== "undefined") {
            if (Object.keys(bonus.bonus_conflicts).length > 0) {
                return;
            }
        }
        if (this.props.onClickedBonus) {
            this.props.onClickedBonus(bonus.bonus_available_id, bonus)
        } else {
            this.props.history.push('/deposit#' + bonus.bonus_available_id)
        }
    }

    render() {
        if (this.props.onClickedBonus && this.props.bonuses !== null && this.props.bonuses.length === 0) {
            this.props.onClickedBonus(-1)
        }
        if (this.props.onClickedBonus && (this.props.freeBets.length > 0 || this.props.freeSpins.length > 0)) {
            this.props.onClickedBonus(-1)
        }


        // if (!this.state.bonus) {

        // return  <div></div>;
        // }
        // if (!this.props.profile) {
        // return <div></div>;
        // }

        // if (!this.props.transactions) {
        // return <div></div>
        // }

        // let currentStep = this.getCurrentStep();
        //
        // if (currentStep === false) {
        //
        //     return <div></div>;
        // }

        // if (this.state.time == 0) {
        //     return <div></div>
        // }
        // let steps = [];
        // if (this.state.bonus.all_values) {
        //
        //     get rid of brackets and split into an array
        // steps = this.state.bonus.all_values.substr(1,this.state.bonus.all_values.length-2).split(",");
        // let ids = this.state.bonus.all_ids.substr(1,this.state.bonus.all_ids.length-2).split(",");
        // if (currentStep.lastValue === 0) {
        //     currentStep = 0;
        // } else {
        //
        //     Object.keys(ids).forEach((key) => {
        //         if (ids[key] == currentStep.lastValue) {
        //             currentStep = parseInt(key)+1;
        //         }
        //     })
        //
        // }
        // if (!steps[currentStep]) {
        //     return <div></div>;
        // }
        //
        // }



        let bonusList = [];
        let bonusListConflicts = [];
        if (this.props.bonusId === -2) {
            bonusList.push(<div
                className={"BonusWidget  compact"} key={`bonusCompactWidget-${this.props.bonusId}`}>
                <div className="details" /*onClick={() => this.props.history.push('/cazino/promotii')}*/>
                    <div className="img">
                        <img
                            src={window.location.protocol + '//' + window.config.cdn_address + "/public/bonus/img-bonuswizard-banner-nobonus%403x.jpg"}
                            alt="" />
                    </div>
                    <div className="other-details"
                        style={{ background: "transparent" }}>
                        <h2 className="title">
                            {this.props.t("No bonus")}

                            <div className={'change'} onClick={this.props.changeBonusClick.bind(this)}>{this.props.t("Change")}</div>
                        </h2>

                    </div>
                </div>

            </div>);
        }

        if (this.props.bonuses) {

            Object.keys(this.props.bonuses).forEach((key) => {
                let skip = false;
                if (this.props.type === "compact") {
                    if (this.props.bonuses[key].bonus_available_id !== this.props.bonusId) {
                        skip = true
                    }
                }
                if (!skip) {
                    let bonus = this.props.bonuses[key]
                    let products = [];
                    if (bonus) {
                        if (bonus.eligible_products) {
                            bonus.eligible_products.forEach((key) => {
                                switch (key) {
                                    case 2:
                                    case "2":
                                        products.push(this.props.t("Sportsbook"));
                                        break;
                                    case 1:
                                    case "1":
                                        products.push(this.props.t("Casino"));
                                        break;
                                    default:
                                        break;

                                }
                            })
                        }


                        let bonusConflicts = [];

                        if (bonus.bonus_conflicts) {
                            Object.keys(bonus.bonus_conflicts).forEach((key, i) => {
                                switch (key) {
                                    case 6:
                                    case "6":
                                        bonusConflicts.push(<div key={i}> * {this.props.t("Wager the active bonuses first")}</div>);
                                        break;
                                    case 19:
                                    case "19":
                                        bonusConflicts.push(<div key={i}> * {this.props.t("Requires email verification")}</div>);
                                        break;
                                    case 20:
                                    case "20":
                                        bonusConflicts.push(<div key={i}> * {this.props.t("Requires identity verification")}</div>);
                                        break;
                                    default:
                                        bonusConflicts.push(<div key={i}> * {this.props.t("Temporarily unavailable")}</div>);
                                        break
                                }
                            })
                        }

                        let bonusReceived;

                        bonusReceived = getSelectedBonusValue(bonus, this.props.depositValue,{bonusAward:this.props.type === 'list' ? false : this.props.bonusAward});
                        if (this.props.type === "compact") {
                            bonusReceived = bonusReceived ? `+${bonusReceived} Bonus` : false;
                        }

                        let bonusHTML = (<div
                            className={"BonusWidget" + (this.props.type === "compact" ? " compact" : "") /*+ (!bonusReceived ? " grayscale" : "")*/} key={"BonusWidget" + bonus.bonus_available_name + bonus.bonus_available_id}>
                            <div className="details" /*onClick={() => this.props.history.push('/cazino/promotii')}*/>
                                <div className="img">
                                    <img
                                        src={this.props.type === "compact" ? bonus.deposit_wizard_image : bonus.icon_image}
                                        alt="" />
                                </div>
                                <div className="other-details"
                                    style={this.props.type === "compact" ? { background: "linear-gradient(90deg, transparent 30%, #f5f8fa 60%)" } : bonus.deposit_wizard_gradient ? { background: bonus.deposit_wizard_gradient } : {}}>
                                    <h2 className="title">
                                        {bonus.bonus_available_name}
                                        {this.props.type === "compact" && this.props.changeBonusClick && (
                                            <div className={'change'} onClick={this.props.changeBonusClick.bind(this)}>{this.props.t("Change bonus")}</div>
                                        )}
                                    </h2>
                                    {this.props.type === "compact" && (
                                        <div className={'deposit-details'}>
                                            {!bonusReceived && (
                                                <div className={'alert'}>
                                                    <div className="atitle">{this.props.t("Bonus requirements:")}</div>
                                                    <div className="list">{this.props.t(this.props.t("Minimum deposit:"))} <strong>{Utils.formatAmount(bonus.bonus_available_min * 100/bonus.bonus_available_amount,false, "Lei")}</strong></div>
                                                </div>
                                            )}
                                            {bonusReceived && (
                                                <div>
                                                    <span className={'bonus-received'}>
                                                        {bonusReceived}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {this.props.type !== "compact" && (<div className="bonus">
                                        <div className="name">
                                            {bonus.bonus_available_name}
                                            <div className="type">
                                                {products.join(', ')}
                                            </div>
                                        </div>
                                        {this.props.type !== "compact" && (<div className="value">
                                            {bonusReceived}
                                        </div>)}
                                    </div>)}
                                </div>
                            </div>
                            {bonusConflicts.length > 0 && <div className="bonus-conflicts">
                                <div>{Icons.get('exWarning')} Conditii de activare neindeplinite:</div>
                                {bonusConflicts}
                            </div>}
                            {this.props.type !== "compact" && (<div className={"cta" + (bonusConflicts.length > 0 ? " disabled" : "")} disabled={bonusConflicts.length > 0}>
                                {this.getTimer(key)}
                                <a className={'button'} onClick={this.clickBonus.bind(this, bonus)}>{this.props.cta_text ? this.props.cta_text : this.props.t("GET BONUS")}</a>
                                {bonus.terms_url && <a href={bonus.terms_url} className={'bonus-terms'} target={"_blank"}>{this.props.t("Terms & conditions")}</a>}
                            </div>)}
                        </div>);
                        if (bonusConflicts.length > 0) {
                            bonusListConflicts.push(bonusHTML);
                        } else {
                            bonusList.push(bonusHTML);
                        }
                    }
                }

            })

            if (this.props.addEmpty) {
                bonusListConflicts.push(<div className={"BonusWidget empty"} key={'emptybonuswidget'}>
                    <div className="details" /*onClick={() => this.props.history.push('/cazino/promotii')}*/>
                        <div className="img">
                            {Icons.get('diamond')}
                        </div>
                        <div className="other-details">
                            <h2 className="title">{this.props.t("No bonus")}</h2>
                        </div>
                    </div>
                    <div className="cta" onClick={this.props.onClickedBonus ? this.props.onClickedBonus.bind(this, -2) : () => this.props.history.push('/deposit')}>
                        {/*{this.getTimer()}*/}
                        <span></span>
                        <a className={'button'}>{this.props.t("Deposit without bonus")}</a>
                    </div>
                </div>);
            }
        }



        if (this.props.type === 'list' || this.props.type === "compact") {

            return (<div>{bonusList}{bonusListConflicts}</div>)
        }
        const slick_settings = {
            dots: true,
            arrows: false,
            autoplay: false,
            easing: "easeOutQuart",
            draggable: true,
            infinite: false,
            slidesToShow: 1.1,
            slidesToScroll: 1,
        };
        return (
            <Slider className={"bonusCarousel"} {...slick_settings} key={'slider-bonus'}>
                {bonusList}
            </Slider>
        );
    }

};

const mapStateToProps = state => {
    return {
        bonuses: state.application.eligibleBonuses,
        profile: state.profile,
        transactions: state.transactions,
        wallet: state.wallet,

        freeBets: state.freeBets.freeBets,
        freeSpins: state.freeSpins.freeSpins,
        bonusAward: state.application.bonusAward
    }
};

const mapDispatchToProps = dispatch => {
    return {
        closeRightMenu: () => dispatch(storeActions.closeRightMenu()),
        getFreeBets: () => dispatch(storeActions.freeBetsFetch()),
        getFreeSpins: () => dispatch(storeActions.freeSpinsFetch()),
        getEligibleBonuses: (paymentMethods = []) => dispatch(stateActions.getEligibleBonuses(paymentMethods))
    };
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)((BonusTile))));
